import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import getElementTop from 'mex_components/app/scripts/elements/getElementTop';
import getHeaderOffset from 'mex_components/app/scripts/media/getHeaderOffset';
import scrollTo from 'mex_components/app/scripts/animation/scrollTo.js';
import { toggleViewAllCards } from './course_detail_card_block';

function instructorSessionsSummaries(instructorSessions) {
  // For each instructor class time,
  // substitute the instructor class times inner html
  // with the corresponding card's content.
  // This will only execute on desktop viewports
  Array.from(instructorSessions).forEach(session => {
    const sessionId = session.getAttribute('data-id');
    const selector = `.course-detail-card--times[data-id="${sessionId}"]`;
    const summary = document.querySelector(selector);
    if (summary) {
      session.innerHTML = summary.innerHTML;
    }
  });
}

addStartupScript(() => {
  const instructorSessions = document.getElementsByClassName('js-instructor-sessions');
  instructorSessionsSummaries(instructorSessions);

  document.addEventListener('click', (event) => {
    const target = event.target;
    const targetId = target.getAttribute('data-id');
    const mediaQuery = window.matchMedia('(min-width: 460px)');

    // Check if event trigger was from an instructor course card
    if (target.classList.contains('js-instructor-view-details')) {
      // Target course detail card with matching id
      const cardTarget = document.querySelector(`.course-detail-card[data-id="${targetId}"]`);
      // Target card index
      const cardIndex = cardTarget.getAttribute('data-index');
      // Target course detail card 'View details' trigger
      const trigger = cardTarget.querySelector('.js-view-details');

      if (mediaQuery.matches) {
        const allDetailCards = document.querySelectorAll('.course-detail-card');
        const viewAllTrigger = document.querySelector('.js-view-all-cards');

        // If triggering hidden desktop card,
        // Unhide all hidden deskop cards
        // then scroll to and click card trigger
        if (viewAllTrigger && cardIndex >= 3) {
            viewAllTrigger.style.display = 'none';
            toggleViewAllCards(allDetailCards);
        }

        scrollTo(getElementTop(cardTarget.parentNode) - getHeaderOffset());
        trigger.click();
      } else {
        trigger.click();
      }
    }
  });
});
